import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import LinkAccountsLoginPage from './LinkAccountsLoginPage';
import {
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    clearAuthNotification as clearAuthNotificationAction,
    forceStld as forceStldAction,
    viewPassword as viewPasswordAction,
} from '../../actions/auth';

import { sendEmailLinkAccount as sendEmailLinkAccountAction } from '../../actions/email';

const _mapStateToProps = ({ authentication, social }) => ({
    email: authentication.email,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    disableRecaptcha3: authentication.disableRecaptcha3,
    socialProvider: social.socialProvider,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
    moveBack: moveBackAction,
    handleClickViewPassword: viewPasswordAction,
    clearAuthNotification: clearAuthNotificationAction,
    onForceStld: forceStldAction,
    handleSendMailLinkAccount: sendEmailLinkAccountAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LinkAccountsLoginPage),
);
